<template>
  <div class="gw-line-chart">
    <div class="gw-line-chart__line-chart">
      <div
        v-if="chartData.ok > 0"
        class="gw-line-chart__line-chart__ok"
        :style="calculatedSize.ok"
      >
        <span>{{ $tc('message.GW_N_OK_ITEMS', chartData.ok, { nb: chartData.ok }) }}</span>
      </div>
      <div
        v-if="chartData.nok > 0"
        class="gw-line-chart__line-chart__nok"
        :style="calculatedSize.nok"
      >
        <span>{{ $tc('message.GW_N_NOK_ITEMS', chartData.nok, { nb: chartData.nok }) }}</span>
      </div>
      <div
        v-if="chartData.na > 0"
        class="gw-line-chart__line-chart__na"
        :style="calculatedSize.na"
      >
        <span>{{ $tc('message.GW_N_NA_ITEMS', chartData.na, { nb: chartData.na }) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * GW line chart
 */

export default {

  name: 'GwLineChart',

  props: {
    values: {
      type: Object,
      required: true,
    },
    stepId: {
      type: Number,
      default: () => 0,
    },
  },

  computed: {
    chartData() {
      if (this.stepId) {
        return this.values.steps[this.stepId];
      }
      return this.values;
    },
    calculatedSize() {
      return {
        ok: `width: ${100 * this.chartData.ok / this.chartData.total}%`,
        nok: `width: ${100 * this.chartData.nok / this.chartData.total}%`,
        na: `width: ${100 * this.chartData.na / this.chartData.total}%`,
      };
    },
  },

  methods: {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.gw-line-chart {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;

  &__line-chart {
    width: 60%;
    height: 1.35rem;
    display: flex;
    font-size: 0.85rem;
    color: white;
    font-weight: 600;
    justify-content: flex-start;
    overflow: hidden;
    border-radius: 5px;

    &__ok {
      background-color: $color-shizen-green;
    }

    &__nok {
      background-color: $color-shizen-red;
    }

    &__na {
      background-color: #d1cfcf;
    }

    div {
      height: 100%;
      display: flex;
      align-items: center;
      transition: width 0.4s;
      min-width: 120px;
      padding-left: 10px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

@media (max-width: $smartphone-landscape) {
  .gw-line-chart {

    &__line-chart {
      width: 100%;
      max-width: 100%;
    }

    div {
      min-width: 100px;
    }
  }
}
</style>
